<style lang='less' scoped>
@import '../base.less';

.settings-container {
  padding: 20px;
  background-color: #f8f9fb;
  min-height: calc(100vh - 120px);
}

.settings-header {
  margin-bottom: 24px;
  
  h1 {
    font-size: 24px;
    font-weight: 600;
    color: #1c2438;
    margin: 0;
    display: flex;
    align-items: center;
    
    .anticon {
      margin-right: 12px;
      color: #2d8cf0;
    }
  }
  
  p {
    color: #8c9aab;
    margin: 8px 0 0 0;
    font-size: 14px;
  }
}

.settings-section {
  margin-bottom: 24px;
  
  .ivu-card {
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    border: 1px solid #e8eaec;
    transition: all 0.3s ease;
    
    &:hover {
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
    }
  }
  
  .section-title {
    font-size: 16px;
    font-weight: 600;
    color: #1c2438;
    margin-bottom: 16px;
    padding-bottom: 8px;
    border-bottom: 2px solid #f0f0f0;
    display: flex;
    align-items: center;
    
    .section-icon {
      margin-right: 8px;
      padding: 4px;
      border-radius: 4px;
      background: #f0f8ff;
      color: #2d8cf0;
    }
  }
}

.form-row {
  margin-bottom: 20px;
  
  .ivu-form-item {
    margin-bottom: 16px;
  }
  
  .ivu-form-item-label {
    font-weight: 500;
    color: #495060 !important;
  }
  
  
  .ivu-form-item-error-tip {
    margin-top: 4px;
    font-size: 12px;
  }
}




// 简化的输入框样式 -乌龟
.ivu-input,
.ivu-select {
  width: 100%;
  
  &:focus {
    border-color: #2d8cf0;
    box-shadow: 0 0 0 2px rgba(45, 140, 240, 0.2);
  }
  
  &.ivu-input-error {
    border-color: #ed4014;
  }
}

.logo-upload-section {
  .logo-preview {
    margin-top: 12px;
    border: 2px dashed #e8eaec;
    border-radius: 8px;
    padding: 16px;
    text-align: center;
    background: #fafbfc;
    
    img {
      max-width: 200px;
      max-height: 150px;
      border-radius: 6px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }
    
    .remove-btn {
      margin-top: 8px;
      background: #ff4d4f;
      color: white;
      border: none;
      padding: 4px 12px;
      border-radius: 4px;
      cursor: pointer;
      font-size: 12px;
      
      &:hover {
        background: #ff7875;
      }
    }
  }
  
  .upload-dragger {
    border: 2px dashed #d9d9d9;
    border-radius: 8px;
    background: #fafafa;
    padding: 20px;
    text-align: center;
    transition: all 0.3s ease;
    
    &:hover {
      border-color: #2d8cf0;
      background: #f0f8ff;
    }
    
    .upload-icon {
      font-size: 24px;
      color: #c5c8ce;
      margin-bottom: 8px;
    }
    
    .upload-text {
      color: #8c9aab;
      font-size: 14px;
    }
  }
}

.editor-container {
  border: 1px solid #e8eaec;
  border-radius: 6px;
  overflow: hidden;
  
  .toolbar {
    border-bottom: 1px solid #e8eaec;
    background: #fafbfc;
  }
  
  .editor-content {
    background: white;
  }
}

.form-actions {
  text-align: center;
  padding: 24px 0;
  border-top: 1px solid #f0f0f0;
  margin-top: 32px;
  
  .ivu-btn-primary {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border: none;
    border-radius: 6px;
    padding: 0 32px;
    height: 40px;
    font-weight: 500;
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
    transition: all 0.3s ease;
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 16px rgba(102, 126, 234, 0.4);
    }
  }
}

.two-column {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
}

.full-width-input {
  .ivu-input,
  .ivu-select {
    width: 100% !important;
  }
}
</style>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<template>
  <div class="settings-container">
    <!-- 页面标题 -->
    <div class="settings-header">
      <h1>
        <Icon type="ios-settings" />
        图库系统设置
      </h1>
      <p>配置您的图库系统基本信息、功能设置和外观选项</p>
    </div>

    <Form :model="windowAddItem" :label-width="140" label-position="left">
      <!-- 基本信息设置 -->
      <div class="settings-section">
        <Card>
          <div class="section-title">
            <Icon type="ios-information-circle" class="section-icon" />
            基本信息设置
          </div>
          
          <div class="two-column">
            <div class="form-row">
              <FormItem label="网站名称" prop="siteTitle">
                <Input 
                  clearable 
                  v-model="windowAddItem.siteTitle" 
                  placeholder="请输入网站标题"
                  size="large"
                />
              </FormItem>
            </div>
            
            <div class="form-row">
              <FormItem label="中间菜单名" prop="midTabName">
                <Input 
                  clearable 
                  v-model="windowAddItem.midTabName" 
                  placeholder="请输入中间菜单名"
                  size="large"
                />
              </FormItem>
            </div>
          </div>
          
          <div class="form-row">
            <FormItem label="中间页面地址" prop="iframUrl">
              <Input 
                clearable 
                v-model="windowAddItem.iframUrl" 
                placeholder="请输入中间页面地址"
                size="large"
                style="width: 100%;"
              />
            </FormItem>
          </div>
        </Card>
      </div>

      <!-- LOGO设置 -->
      <div class="settings-section">
        <Card>
          <div class="section-title">
            <Icon type="ios-image" class="section-icon" />
            LOGO设置
          </div>
          
          <div class="logo-upload-section">
            <FormItem label="网站LOGO链接" prop="logo">
              <Input 
                clearable 
                v-model="windowAddItem.logo" 
                placeholder="请输入图片的链接地址"
                size="large"
                style="width: 100%;"
              />
            </FormItem>
            
            <Row>
              <Col span="12">
                <div class="logo-preview" v-if="windowAddItem.logo">
                  <img :src="windowAddItem.logo" alt="网站LOGO预览">
                  <div>
                    <Button 
                      class="remove-btn" 
                      @click="handleImgRemove('logo')"
                      size="small"
                    >
                      <Icon type="ios-trash" /> 移除图片
                    </Button>
                  </div>
                </div>
                
                <Upload 
                  v-if="!windowAddItem.logo"
                  type="drag" 
                  :action="uploadUrl" 
                  :headers="uploadHeader"
                  :format="['jpg','jpeg','png','gif']" 
                  :max-size="5120"
                  :on-success="v=>{handleImgSuccess(v,'logo')}"
                  :on-format-error="handleImgFormatError" 
                  :on-exceeded-size="handleImgMaxSize"
                  class="upload-dragger"
                >
                  <div>
                    <Icon type="ios-cloud-upload" class="upload-icon" />
                    <div class="upload-text">点击或拖拽上传LOGO</div>
                    <div class="upload-text">支持 JPG、PNG、GIF 格式，大小不超过5MB</div>
                  </div>
                </Upload>
              </Col>
            </Row>
          </div>
        </Card>
      </div>

      <!-- 域名配置 -->
      <div class="settings-section">
        <Card>
          <div class="section-title">
            <Icon type="ios-cloud" class="section-icon" />
            域名与地址配置
          </div>
          
          <div class="form-row">
            <FormItem label="本站图片域名" prop="imgBaseUrl">
              <Input 
                clearable 
                v-model="windowAddItem.imgBaseUrl" 
                placeholder="请输入本站图片域名(本站上传图片域名)"
                size="large"
                style="width: 100%;"
              />
            </FormItem>
          </div>
          
          <div class="form-row">
            <FormItem label="评论图片上传路径" prop="imgUploadUrl">
              <Input 
                clearable 
                v-model="windowAddItem.imgUploadUrl" 
                placeholder="请输入本站评论图片上传路径"
                size="large"
                style="width: 100%;"
              />
            </FormItem>
          </div>
          
          <div class="form-row">
            <FormItem label="主站图片域名" prop="selfImageUrl">
              <Input 
                clearable 
                v-model="windowAddItem.selfImageUrl" 
                placeholder="请输入主站图片域名"
                size="large"
                style="width: 100%;"
              />
            </FormItem>
          </div>
          
          <div class="form-row">
            <FormItem label="主站域名" prop="mainTukuUrl">
              <Input 
                clearable 
                v-model="windowAddItem.mainTukuUrl" 
                placeholder="请输入主站域名(用于同步图库)"
                size="large"
                style="width: 100%;"
              />
            </FormItem>
          </div>
        </Card>
      </div>

      <!-- 应用下载与分享 -->
      <div class="settings-section">
        <Card>
          <div class="section-title">
            <Icon type="ios-download" class="section-icon" />
            应用下载与分享
          </div>
          
          <div class="two-column">
            <div class="form-row">
              <FormItem label="苹果下载地址" prop="iosDownUrl">
                <Input 
                  clearable 
                  v-model="windowAddItem.iosDownUrl" 
                  placeholder="请输入苹果下载地址"
                  size="large"
                  style="width: 100%;"
                />
              </FormItem>
            </div>
            
            <div class="form-row">
              <FormItem label="安卓下载地址" prop="androidDownUrl">
                <Input 
                  clearable 
                  v-model="windowAddItem.androidDownUrl" 
                  placeholder="请输入安卓下载地址"
                  size="large"
                  style="width: 100%;"
                />
              </FormItem>
            </div>
          </div>
          
          <div class="two-column">
            <div class="form-row">
              <FormItem label="分享链接" prop="shareUrl">
                <Input 
                  clearable 
                  v-model="windowAddItem.shareUrl" 
                  placeholder="请输入用户分享的链接"
                  size="large"
                  style="width: 100%;"
                />
              </FormItem>
            </div>
            
            <div class="form-row">
              <FormItem label="客服链接" prop="kefu">
                <Input 
                  clearable 
                  v-model="windowAddItem.kefu" 
                  placeholder="请输入客服链接"
                  size="large"
                  style="width: 100%;"
                />
              </FormItem>
            </div>
          </div>
        </Card>
      </div>

      <!-- 系统配置 -->
      <div class="settings-section">
        <Card>
          <div class="section-title">
            <Icon type="ios-cog" class="section-icon" />
            系统配置
          </div>
          
          <div class="two-column">
            <div class="form-row">
              <FormItem label="图片源设置" prop="isSelfImage">
                <Select v-model="windowAddItem.isSelfImage" size="large" style="width: 100%;">
                  <Option value="0">使用采集的图库地址</Option>
                  <Option value="1">使用自己的图库地址</Option>
                </Select>
              </FormItem>
            </div>
            
            <div class="form-row">
              <FormItem label="维护状态" prop="isWeihu">
                <Select v-model="windowAddItem.isWeihu" size="large" style="width: 100%;">
                  <Option value="0">正常运行</Option>
                  <Option value="1">维护中</Option>
                </Select>
              </FormItem>
            </div>
          </div>
          
          <div class="form-row">
            <FormItem label="统计JS代码" prop="tongji_js">
              <Input 
                clearable 
                v-model="windowAddItem.tongji_js" 
                placeholder="请输入统计JS代码"
                size="large"
                style="width: 100%;"
              />
            </FormItem>
          </div>
        </Card>
      </div>

      <!-- 内容编辑 -->
      <div class="settings-section">
        <Card>
          <div class="section-title">
            <Icon type="ios-create" class="section-icon" />
            内容编辑
          </div>
          
          <div class="form-row">
            <FormItem label="关于我们" prop="about">
              <div class="editor-container">
                <Toolbar
                  class="toolbar"
                  :editor="editor"
                  :defaultConfig="toolbarConfig"
                  :mode="mode"
                />
                <Editor
                  class="editor-content"
                  style="height: 200px; overflow-y: hidden;"
                  v-model="windowAddItem['about']"
                  :defaultConfig="editorConfig"
                  :mode="mode"
                  @onCreated="onCreated"
                />
              </div>
            </FormItem>
          </div>

          <div class="form-row">
            <FormItem label="广告投放" prop="adToufan">
              <div class="editor-container">
                <Toolbar
                  class="toolbar"
                  :editor="editor2"
                  :defaultConfig="toolbarConfig2"
                  :mode="mode2"
                />
                <Editor
                  class="editor-content"
                  style="height: 200px; overflow-y: hidden;"
                  v-model="windowAddItem['adToufan']"
                  :defaultConfig="editorConfig2"
                  :mode="mode2"
                  @onCreated="onCreated2"
                />
              </div>
            </FormItem>
          </div>
        </Card>
      </div>

      <!-- 提交按钮 -->
      <div class="form-actions">
        <Button type="primary" @click="windowAddSubmit" size="large">
          <Icon type="ios-checkmark" />
          保存设置
        </Button>
      </div>
    </Form>
  </div>
</template>
<script>
import {Editor, Toolbar} from '@wangeditor/editor-for-vue'

import {
  customPost
} from '@/api/Lhc/Lhc'

import {
  formattingMonth,
  lastMonthDate
} from '@/libs/time'
import {
  baseUrl
} from '@/libs/api.request'
import {
  getToken
} from '@/libs/util'

export default {
  name: 'interface_list',
  components: {Editor, Toolbar},
  data() {
    return {
      editor: null,
      toolbarConfig: {},
      editorConfig: {placeholder: '请输入内容...'},
      mode: 'default', // or 'simple',
      editor2: null,
      toolbarConfig2: {},
      editorConfig2: {placeholder: '请输入内容...'},
      mode2: 'default', // or 'simple',
      isHtml: false,
      uploadUrlCk: baseUrl + 'Index/uploadCk',
      uploadUrl: baseUrl + 'Index/upload',
      uploadHeader: {
        'Authorization': "bearer " + getToken()
      },
      timeOptions: {
        shortcuts: [{
          text: '今天',
          value() {
            let a = new Date(new Date(new Date().toLocaleDateString()).getTime())
            let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 *
              1000 - 1)
            return [a, b]
          }
        },
          {
            text: '昨天',
            value() {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 *
                1000)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 *
                1000 + 24 * 60 *
                60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '一周',
            value() {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 *
                1000 * 7)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 *
                1000 - 1)
              return [a, b]
            }
          },
          {
            text: '本月',
            value() {
              return formattingMonth()
            }
          },
          {
            text: '上月',
            value() {
              return lastMonthDate()
            }
          },
        ]
      },
      columnsList: [],
      tableData: [], //用于放LIST数据绑定
      tableShow: { //用于分页
        currentPage: 1,
        pageSize: 10,
        listCount: 0
      },
      searchConf: {
        searchTime: [],
      }, // 搜索字段
      extraParams: [],
      buttonShow: { //按钮状态显示
        edit: true,
        del: true,
        changeStatus: true
      },
      listLoading: false, //显示加载中状态
      //弹窗--------------
      windowAdd: { //弹窗
        show: false,
        loading: false,
        index: 0
      },
      windowAddItem: { //弹窗数据绑定
        id: 0,
        logo: '',
        templatePath: '',
        js: ""
      },
      windowAddValidate: { //窗口校验规则
      }, //----------------
    }
  },

  created() {
    let vm = this
    vm.getList()
    vm.hasRule('systemManage/siteSetting/edit').then(res => {
      vm.buttonShow.edit = res
    })
    vm.hasRule('systemManage/siteSetting/del').then(res => {
      vm.buttonShow.del = res
    })
    vm.hasRule('systemManage/siteSetting/changeStatus').then(res => {
      vm.buttonShow.changeStatus = res
    })
  },
  mounted() {
    this.getParams()
  },
  methods: {
    onCreated(editor) {
      this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
    },
    onCreated2(editor) {
      this.editor2 = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
    },
    preAdd() {
      let vm = this
      vm.windowAdd.show = true
    },
    getParams() {
      // getParams().then(response => {
      //     this.extraParams = response.data.data
      // })
    },
    changePage(page) {
      this.tableShow.currentPage = page
      this.getList()
    },
    changeSize(size) {
      this.tableShow.pageSize = size
      this.getList()
    },
    search() {
      this.tableShow.currentPage = 1
      this.getList()
    },
    getList() {
      let vm = this
      vm.listLoading = true
      vm.windowAddItem.op='';
      customPost('Tuku/getSiteConfig', {op:''}).then(response => {
        vm.windowAddItem = response.data.data
      })

    },

    timeChange(datetimerange) { //时间修改，自动计算尾部时间
      if (datetimerange[0] !== '' && datetimerange[1] !== '') {
        let patt = /00:00:00/
        this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        if (patt.test(datetimerange[1])) {
          datetimerange[1] = datetimerange[1].replace('00:00:00', '23:59:59')
          this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        }
      } else {
        this.searchConf.searchTime = []
      }
    },
    sortChange: function ({
                            column,
                            key,
                            order
                          }) {
      //order值可能为asc,desc,normal
      this.searchConf.order = [key, order]
      if (order == 'normal') {
        this.searchConf.order = []
      }
      this.getList()
    },
    windowAddCancel(data) {
      if (!data) {
        this.windowAddItem.id = 0
        this.$refs['windowAddForm'].resetFields()
        this.windowAdd.show = false
        this.windowAdd.loading = false
        this.windowAdd.index = 0
      }
    },
    windowAddSubmit() {
      let vm = this
      vm.windowAdd.loading = true
      vm.windowAddItem.op='save';
      customPost('Tuku/getSiteConfig',vm.windowAddItem).then(response => {
        vm.$Message.success(response.data.msg)
        vm.getList()
        vm.windowAddCancel()
      })
    },
    handleImgFormatError(file) {
      this.$Notice.warning({
        title: '文件类型不合法',
        desc: file.name + '的文件类型不正确，请上传jpg或者png图片。'
      })
    },
    handleImgRemove(key) {
      this.windowAddItem[key] = ''
    },
    handleImgSuccess(response, key) {
      if (response.code === 1) {
        this.$Message.success(response.msg)
        if (response.data.fileUrl.startsWith('http')) {
          this.windowAddItem[key] = response.data.fileUrl
        } else {
          this.windowAddItem[key] = response.data.showUrl
          console.log(this.windowAddItem.js)
          this.$forceUpdate();
        }
      } else {
        this.$Message.error(response.msg)
      }
    },
    handleImgMaxSize(file) {
      this.$Notice.warning({
        title: '文件大小不合法',
        desc: file.name + '太大啦请上传小于5M的文件。'
      })
    },
  }
}
</script>
